/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gamecompanies_Supercell1Inputs */

const ja_gamecompanies_supercell1 = /** @type {(inputs: Gamecompanies_Supercell1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Supercell`)
};

const en_gamecompanies_supercell1 = /** @type {(inputs: Gamecompanies_Supercell1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Supercell`)
};

/**
* | output |
* | --- |
* | "Supercell" |
*
* @param {Gamecompanies_Supercell1Inputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
const gamecompanies_supercell1 = /** @type {((inputs?: Gamecompanies_Supercell1Inputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gamecompanies_Supercell1Inputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ja") return ja_gamecompanies_supercell1(inputs)
	return en_gamecompanies_supercell1(inputs)
});
export { gamecompanies_supercell1 as "gameCompanies_supercell" }